export default __webpack_public_path__ + "static/media/Download.07be4257.svg";